import { MCCValidValues } from "./MCCList"

export type CreatePaymentAccountPayload = {
    merchantName: string
    mcc: number
    locationIDs: string[]
}

export const isFormValid = (form: CreatePaymentAccountPayload): boolean => {
    return form.merchantName.length > 1 && MCCValidValues.includes(form.mcc) && form.locationIDs.length > 0
}


// WEBPACK FOOTER //
// ./src/payment-processing/merchant-onboarding/PaymentAccountPayload.ts